export const FIFTEEN_DAYS = 15 * 24 * 60 * 60 * 1000;
export const TOKEN_STORAGE_KEY = 'LIVE_RAMP';

// TODO move to ENV
export const APP_LIVE_RAMP_URL = 'https://api.rlcdn.com/api/identity/envelope';
export const APP_LIVE_RAMP_PID = '13429';
export const APP_LIVE_RAMP_IT = '4';
export const APP_LIVE_RAMP_REFRESH_IT = '19';
export const APP_LIVE_RAMP_ORIGIN_HEADER = 'https://app.twcdtc.com';
